import { useRouter } from 'next/router';
import { decodePage, encodePage, pruneQuery } from '../queryEncoding';

/**
 * Use page option persisted in the url query
 *
 * Changing pages results in a router.push, which will trigger a data reload
 */
export const usePaging = () => {
  const { push, pathname, query } = useRouter();

  const { pageSize, currentPage = 1, pagingMode } = decodePage(query);

  const pushPageChange = (newPage: number, keepScrollPosition?: boolean) => {
    push(
      {
        // currently the /c/ prefix is internal-only, and rewritten in the middleware
        pathname: pathname.replace(/^\/c/, '').concat('/'),
        query: pruneQuery({ ...query, ...encodePage(newPage !== 1 ? newPage : undefined) }),
      },
      undefined,
      {
        scroll: !keepScrollPosition,
      },
    );
  };

  const pushPagingMode = (newPagingMode: 'limited' | 'infinite') => {
    push({
      pathname: pathname.replace(/^\/c/, '').concat('/'),
      query: pruneQuery({ ...query, ...encodePage(newPagingMode === 'infinite' ? 0 : undefined) }),
    });
  };

  return {
    pageSize,
    currentPage,
    pagingMode,
    pushPageChange,
    pushPagingMode,
  };
};
